import { render, staticRenderFns } from "./purpose.vue?vue&type=template&id=17086b0a&scoped=true&"
import script from "./purpose.vue?vue&type=script&lang=js&"
export * from "./purpose.vue?vue&type=script&lang=js&"
import style0 from "./purpose.vue?vue&type=style&index=0&id=17086b0a&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17086b0a",
  null
  
)

export default component.exports